import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_AGGREGATE_STORE_PERFORMANCE = `${URL_RETAILER_SCOPED}/aggregate-store-performance`
const URL_AGGREGATE_STORE_PERFORMANCE_OVERVIEW = `${URL_AGGREGATE_STORE_PERFORMANCE}/overview`
const URL_AGGREGATE_STORE_PERFORMANCE_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/aggregate-store-performance`
const URL_AGGREGATE_STORE_PERFORMANCE_OVERVIEW_PARTNER_SCOPED = `${URL_AGGREGATE_STORE_PERFORMANCE_PARTNER_SCOPED}/overview`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'aggregate-store-performance'>
  | DashRouteType<'aggregate-store-performance-overview'>
  | DashRouteType<'aggregate-store-performance-partner-scoped'>
  | DashRouteType<'aggregate-store-performance-overview-partner-scoped'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'aggregate-store-performance': URL_AGGREGATE_STORE_PERFORMANCE,
  'aggregate-store-performance-overview': URL_AGGREGATE_STORE_PERFORMANCE_OVERVIEW,
  'aggregate-store-performance-partner-scoped': URL_AGGREGATE_STORE_PERFORMANCE_PARTNER_SCOPED,
  'aggregate-store-performance-overview-partner-scoped':
    URL_AGGREGATE_STORE_PERFORMANCE_OVERVIEW_PARTNER_SCOPED,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
